export default "<app-gis-map-widget-ff [otherOptions]=\"otherOptions\" mapId='mapId6'></app-gis-map-widget-ff>\n"